import type { JSX } from "react";

/** Full-viewport loading state, announced politely. */
export function FullPageSpinner({
  label = "Loading MailFlare",
}: {
  readonly label?: string;
}): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-background flex min-h-dvh items-center justify-center"
    >
      <span className="text-muted-foreground flex items-center gap-2 text-sm">
        <span className="border-primary size-4 animate-spin rounded-full border-2 border-t-transparent" />
        {label}
      </span>
    </div>
  );
}
